import { navLinks } from "@/mocks/narutoData";

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-sparkling-2-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">火影同人集</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              火影忍者同人作品聚合与导航站，按角色、CP、题材分类整理热门同人合集与优质推荐。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((l) => (
                <li key={l.key}>
                  <a
                    href={`#${l.key}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(l.key);
                    }}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-500"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">热门专题</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-600">
              <li>宇智波佐助同人合集</li>
              <li>漩涡鸣人同人合集</li>
              <li>佐鸣 CP 专题</li>
              <li>日常治愈向合集</li>
              <li>长篇正剧推荐</li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">联系我们</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500" /> contact@example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500" /> 每日更新
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-question-line text-primary-500" /> 投稿与合作欢迎来信
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-3">
              <a href="#top" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }} aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-foreground-600 transition-colors hover:border-primary-500 hover:text-primary-500">
                <i className="ri-weibo-line" />
              </a>
              <a href="#top" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }} aria-label="贴吧" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-foreground-600 transition-colors hover:border-primary-500 hover:text-primary-500">
                <i className="ri-chat-smile-3-line" />
              </a>
              <a href="#top" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }} aria-label="社区" className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 text-foreground-600 transition-colors hover:border-primary-500 hover:text-primary-500">
                <i className="ri-community-line" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-200 pt-6">
          <p className="text-xs text-foreground-600">
            © 2026 火影忍者同人官网 · 本站仅做同人作品导航整理，著作权归原作者所有
          </p>
          <p className="text-xs text-foreground-600">火影忍者同人 · 合集 · 推荐 · 导航 · 目录</p>
        </div>
      </div>
    </footer>
  );
}